import { DateFormatStyle } from "utils/datetimeHelper";

export const isUS = import.meta.env.VITE_APP_LOCALIZATION === "US";

export const localization = import.meta.env.VITE_APP_LOCALIZATION;
export const localizationDateFormat = isUS
  ? DateFormatStyle.MonthDayDate
  : DateFormatStyle.DayMonthYear;

export const localizationDateTimeFormat = isUS
  ? DateFormatStyle.MonthDayDateTime
  : DateFormatStyle.DayMonthYearTime;

export const localizationDateWithDashes = isUS
  ? DateFormatStyle.MonthDayYearDash
  : DateFormatStyle.DayMonthYearDash;

export const localizationDateWithSlashes = isUS
  ? DateFormatStyle.MonthDayYearSlash
  : DateFormatStyle.DayMonthYearSlash;

export const localizationRouteComponent = isUS ? "" : "/en-gb";
export const currency = isUS ? "USD" : "GBP";
export const currencySymbol = isUS ? "$" : "£";
export const localizedNumber = isUS ? "+1 888 402-3972" : "+44 203 038 2598";
export const helloEmail = import.meta.env.VITE_APP_EZRA_HELLO_EMAIL;

export const localizationPageTitleRegion = `Ezra | Function ${localization}`;

export const localizedPostalRegex = isUS
  ? /(^\d{5}(?:[-\s]\d{4})?$)/
  : /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|^(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;

export const supportedLocales = ["en-us", "en-gb"];

export const localizedPrivacyEmail = isUS
  ? "privacy@ezra.com"
  : "privacy@uk.ezra.com";
